var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GrayBlockContainer',{staticClass:"flex flex-col",staticStyle:{"gap":"24px"}},[_c('p',{staticClass:"section-title"},[_vm._v("預約明細")]),_c('AppointmentCheckoutDetailBlock'),_c('AppointmentPaymentMethodsBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }